module.exports = __webpack_public_path__ + "img/price.647a697.svg";